package xyz.qwewqa.relive.simulator.core.gen

/*
10001:
  _id_: 10001
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10292
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10002:
  _id_: 10002
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 89
  skill_option1_target_id: 1143
  skill_option1_time: 0
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10003:
  _id_: 10003
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 28
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 30000
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10004:
  _id_: 10004
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10250
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10005:
  _id_: 10005
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4011
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10006:
  _id_: 10006
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10298
  skill_option1_target_id: 2002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10007:
  _id_: 10007
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10295
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10008:
  _id_: 10008
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10240
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10009:
  _id_: 10009
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10302
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10010:
  _id_: 10010
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10283
  skill_option1_target_id: 4156
  skill_option1_time: 6
  skill_option1_value: 15
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10011:
  _id_: 10011
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10299
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 10294
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10012:
  _id_: 10012
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4009
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10013:
  _id_: 10013
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10283
  skill_option1_target_id: 4157
  skill_option1_time: 6
  skill_option1_value: 15
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10014:
  _id_: 10014
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10311
  skill_option1_target_id: 1002
  skill_option1_time: 5
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10015:
  _id_: 10015
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4011
  skill_option1_time: 6
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10016:
  _id_: 10016
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10310
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 99999
  skill_option2_hit_rate: 100
  skill_option2_id: 10309
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10017:
  _id_: 10017
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10110
  skill_option1_target_id: 1002
  skill_option1_time: 7
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10018:
  _id_: 10018
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10300
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10314
  skill_option2_target_id: 2002
  skill_option2_time: 1
  skill_option2_value: 5
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10019:
  _id_: 10019
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10316
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10303
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10020:
  _id_: 10020
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10318
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10021:
  _id_: 10021
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4008
  skill_option1_time: 6
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10022:
  _id_: 10022
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10314
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 5
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4013
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10023:
  _id_: 10023
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10292
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10322
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10024:
  _id_: 10024
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10328
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10298
  skill_option3_target_id: 4197
  skill_option3_time: 3
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10025:
  _id_: 10025
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10280
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10294
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10026:
  _id_: 10026
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4013
  skill_option1_time: 6
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10027:
  _id_: 10027
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4010
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10028:
  _id_: 10028
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10299
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 10286
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10029:
  _id_: 10029
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4013
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10030:
  _id_: 10030
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10339
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10340
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10031:
  _id_: 10031
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4156
  skill_option1_time: 6
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10032:
  _id_: 10032
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10343
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 1
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10033:
  _id_: 10033
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10345
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10034:
  _id_: 10034
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10302
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10316
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10035:
  _id_: 10035
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10110
  skill_option1_target_id: 1002
  skill_option1_time: 5
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10280
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10036:
  _id_: 10036
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4011
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10037:
  _id_: 10037
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4157
  skill_option1_time: 6
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10038:
  _id_: 10038
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10349
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10348
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10039:
  _id_: 10039
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10050
  skill_option1_target_id: 2002
  skill_option1_time: 4
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10294
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10040:
  _id_: 10040
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4008
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10041:
  _id_: 10041
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10301
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10042:
  _id_: 10042
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10354
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 10355
  skill_option2_target_id: 2002
  skill_option2_time: 1
  skill_option2_value: 2
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10043:
  _id_: 10043
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4009
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10044:
  _id_: 10044
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4012
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10045:
  _id_: 10045
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10347
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10362
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10046:
  _id_: 10046
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10050
  skill_option1_target_id: 2002
  skill_option1_time: 4
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10294
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10047:
  _id_: 10047
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10363
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10048:
  _id_: 10048
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10365
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10367
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10300
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10049:
  _id_: 10049
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4011
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10050:
  _id_: 10050
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10364
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10051:
  _id_: 10051
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10368
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10052:
  _id_: 10052
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10310
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 99999
  skill_option2_hit_rate: 100
  skill_option2_id: 10371
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10053:
  _id_: 10053
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4010
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10054:
  _id_: 10054
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4013
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10055:
  _id_: 10055
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10302
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10380
  skill_option2_target_id: 2002
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10056:
  _id_: 10056
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10343
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 1
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10057:
  _id_: 10057
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10381
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10058:
  _id_: 10058
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10387
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10059:
  _id_: 10059
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4009
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10382
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10060:
  _id_: 10060
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4008
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10061:
  _id_: 10061
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10381
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10389
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10311
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10062:
  _id_: 10062
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10302
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10390
  skill_option2_target_id: 2002
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10063:
  _id_: 10063
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10110
  skill_option1_target_id: 1002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 4228
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10064:
  _id_: 10064
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10394
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10065:
  _id_: 10065
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4012
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10066:
  _id_: 10066
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10399
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10347
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10067:
  _id_: 10067
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10402
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10347
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10068:
  _id_: 10068
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10404
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10069:
  _id_: 10069
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4013
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10070:
  _id_: 10070
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10405
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10071:
  _id_: 10071
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10283
  skill_option1_target_id: 4156
  skill_option1_time: 6
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10072:
  _id_: 10072
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10404
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10073:
  _id_: 10073
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4011
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10074:
  _id_: 10074
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4010
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10402
  skill_option3_target_id: 2002
  skill_option3_time: 1
  skill_option3_value: 2
  skill_option4_hit_rate: 100
  skill_option4_id: 10390
  skill_option4_target_id: 2002
  skill_option4_time: 4
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10075:
  _id_: 10075
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10402
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10300
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10076:
  _id_: 10076
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10050
  skill_option1_target_id: 2002
  skill_option1_time: 4
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10294
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10077:
  _id_: 10077
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10283
  skill_option1_target_id: 4157
  skill_option1_time: 6
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10078:
  _id_: 10078
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10350
  skill_option1_target_id: 1141
  skill_option1_time: 99
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10345
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10396
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 10300
  skill_option4_target_id: 2002
  skill_option4_time: 2
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 10356
  skill_option5_target_id: 2002
  skill_option5_time: 2
  skill_option5_value: 0
10079:
  _id_: 10079
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10347
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10352
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10301
  skill_option4_target_id: 2002
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10080:
  _id_: 10080
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10399
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10416
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 2
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10081:
  _id_: 10081
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4012
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10100
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 20
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 4012
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10082:
  _id_: 10082
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4009
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10083:
  _id_: 10083
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10407
  skill_option1_target_id: 2002
  skill_option1_time: 3
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10423
  skill_option2_target_id: 2002
  skill_option2_time: 6
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10424
  skill_option3_target_id: 2002
  skill_option3_time: 6
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10084:
  _id_: 10084
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 1002
  skill_option1_time: 5
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10376
  skill_option2_target_id: 1002
  skill_option2_time: 5
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10300
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10085:
  _id_: 10085
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10407
  skill_option1_target_id: 2002
  skill_option1_time: 3
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10311
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10399
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10086:
  _id_: 10086
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10412
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10404
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10300
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10087:
  _id_: 10087
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10343
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 1
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10299
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10088:
  _id_: 10088
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10405
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10089:
  _id_: 10089
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4008
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10423
  skill_option3_target_id: 2002
  skill_option3_time: 4
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10424
  skill_option4_target_id: 2002
  skill_option4_time: 4
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10090:
  _id_: 10090
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4156
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10091:
  _id_: 10091
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10407
  skill_option1_target_id: 2002
  skill_option1_time: 3
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10311
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10404
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10092:
  _id_: 10092
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10385
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10345
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 100
  skill_option4_hit_rate: 100
  skill_option4_id: 10316
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 100
  skill_option5_hit_rate: 100
  skill_option5_id: 10300
  skill_option5_target_id: 2002
  skill_option5_time: 2
  skill_option5_value: 50
10093:
  _id_: 10093
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10343
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 1
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10299
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10094:
  _id_: 10094
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4090
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10357
  skill_option2_target_id: 4090
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 4090
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10303
  skill_option4_target_id: 4090
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10319
  skill_option5_target_id: 4090
  skill_option5_time: 2
  skill_option5_value: 0
10095:
  _id_: 10095
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10445
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10300
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 10396
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 10299
  skill_option5_target_id: 1002
  skill_option5_time: 2
  skill_option5_value: 15
10096:
  _id_: 10096
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4093
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10406
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10097:
  _id_: 10097
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10300
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10400
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 2
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10098:
  _id_: 10098
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10450
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 10448
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 20
  skill_option3_hit_rate: 100
  skill_option3_id: 10447
  skill_option3_target_id: 1002
  skill_option3_time: 4
  skill_option3_value: 10
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10099:
  _id_: 10099
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10451
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 10422
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10100:
  _id_: 10100
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4011
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10392
  skill_option3_target_id: 2002
  skill_option3_time: 4
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10101:
  _id_: 10101
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4157
  skill_option1_time: 6
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10102:
  _id_: 10102
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10454
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10404
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10300
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 10396
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10103:
  _id_: 10103
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10444
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10345
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 100
  skill_option4_hit_rate: 100
  skill_option4_id: 10416
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 2
  skill_option5_hit_rate: 100
  skill_option5_id: 10300
  skill_option5_target_id: 2002
  skill_option5_time: 2
  skill_option5_value: 50
10104:
  _id_: 10104
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 1002
  skill_option1_time: 3
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 10459
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 100
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10105:
  _id_: 10105
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10451
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10434
  skill_option2_target_id: 1141
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 10422
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10106:
  _id_: 10106
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10282
  skill_option1_target_id: 4008
  skill_option1_time: 6
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10447
  skill_option2_target_id: 1002
  skill_option2_time: 3
  skill_option2_value: 30
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 4008
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
10107:
  _id_: 10107
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10444
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10345
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 100
  skill_option4_hit_rate: 100
  skill_option4_id: 10416
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 2
  skill_option5_hit_rate: 100
  skill_option5_id: 10300
  skill_option5_target_id: 2002
  skill_option5_time: 2
  skill_option5_value: 50
10108:
  _id_: 10108
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10298
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 4090
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10282
  skill_option3_target_id: 4090
  skill_option3_time: 6
  skill_option3_value: 30
  skill_option4_hit_rate: 100
  skill_option4_id: 10461
  skill_option4_target_id: 2404
  skill_option4_time: 3
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10456
  skill_option5_target_id: 2404
  skill_option5_time: 3
  skill_option5_value: 50
10109:
  _id_: 10109
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10338
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 30
  skill_option2_hit_rate: 100
  skill_option2_id: 10319
  skill_option2_target_id: 4009
  skill_option2_time: 4
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10461
  skill_option3_target_id: 2002
  skill_option3_time: 4
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10343
  skill_option4_target_id: 1002
  skill_option4_time: 3
  skill_option4_value: 1
  skill_option5_hit_rate: 100
  skill_option5_id: 10456
  skill_option5_target_id: 4230
  skill_option5_time: 3
  skill_option5_value: 50
10110:
  _id_: 10110
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10458
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10449
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 15
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10396
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 10404
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 0
10111:
  _id_: 10111
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10434
  skill_option1_target_id: 4007
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10454
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10467
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10300
  skill_option4_target_id: 2002
  skill_option4_time: 2
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 10396
  skill_option5_target_id: 1002
  skill_option5_time: 2
  skill_option5_value: 50
10112:
  _id_: 10112
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10434
  skill_option1_target_id: 4006
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10454
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10447
  skill_option3_target_id: 1001
  skill_option3_time: 1
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 10445
  skill_option4_target_id: 2123
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10396
  skill_option5_target_id: 1002
  skill_option5_time: 2
  skill_option5_value: 50
10113:
  _id_: 10113
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10298
  skill_option1_target_id: 2002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10396
  skill_option2_target_id: 4156
  skill_option2_time: 2
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 10282
  skill_option3_target_id: 4156
  skill_option3_time: 6
  skill_option3_value: 30
  skill_option4_hit_rate: 100
  skill_option4_id: 10461
  skill_option4_target_id: 4230
  skill_option4_time: 3
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10471
  skill_option5_target_id: 1002
  skill_option5_time: 3
  skill_option5_value: 100
10114:
  _id_: 10114
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10434
  skill_option1_target_id: 1143
  skill_option1_time: 2
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10469
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10467
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10451
  skill_option4_target_id: 2002
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10449
  skill_option5_target_id: 1002
  skill_option5_time: 2
  skill_option5_value: 15
10115:
  _id_: 10115
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10434
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10451
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 3
  skill_option3_value: 25
  skill_option4_hit_rate: 100
  skill_option4_id: 10396
  skill_option4_target_id: 1002
  skill_option4_time: 3
  skill_option4_value: 50
  skill_option5_hit_rate: 100
  skill_option5_id: 10422
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 0
10116:
  _id_: 10116
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10450
  skill_option1_target_id: 1002
  skill_option1_time: 4
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 10448
  skill_option2_target_id: 1002
  skill_option2_time: 4
  skill_option2_value: 30
  skill_option3_hit_rate: 100
  skill_option3_id: 10447
  skill_option3_target_id: 1002
  skill_option3_time: 4
  skill_option3_value: 30
  skill_option4_hit_rate: 100
  skill_option4_id: 10443
  skill_option4_target_id: 2002
  skill_option4_time: 3
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10449
  skill_option5_target_id: 1002
  skill_option5_time: 4
  skill_option5_value: 25
20001:
  _id_: 20001
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10285
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20002:
  _id_: 20002
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10285
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20003:
  _id_: 20003
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10080
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20004:
  _id_: 20004
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10293
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20005:
  _id_: 20005
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4011
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20006:
  _id_: 20006
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10150
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20007:
  _id_: 20007
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10150
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20008:
  _id_: 20008
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10150
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20009:
  _id_: 20009
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10285
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20010:
  _id_: 20010
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 8
  skill_option1_target_id: 4156
  skill_option1_time: 4
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20011:
  _id_: 20011
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10293
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20012:
  _id_: 20012
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4009
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20013:
  _id_: 20013
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 8
  skill_option1_target_id: 4157
  skill_option1_time: 4
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20014:
  _id_: 20014
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20015:
  _id_: 20015
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4011
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20016:
  _id_: 20016
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20017:
  _id_: 20017
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10080
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20018:
  _id_: 20018
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20019:
  _id_: 20019
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10250
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20020:
  _id_: 20020
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10250
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20021:
  _id_: 20021
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4008
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20022:
  _id_: 20022
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10319
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20023:
  _id_: 20023
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20024:
  _id_: 20024
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10322
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20025:
  _id_: 20025
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10250
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20026:
  _id_: 20026
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4013
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20027:
  _id_: 20027
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4010
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20028:
  _id_: 20028
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20029:
  _id_: 20029
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4013
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20030:
  _id_: 20030
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10297
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20031:
  _id_: 20031
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4156
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20032:
  _id_: 20032
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10322
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20033:
  _id_: 20033
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10309
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20034:
  _id_: 20034
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10309
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20035:
  _id_: 20035
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4012
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20036:
  _id_: 20036
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10319
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20037:
  _id_: 20037
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 392
  skill_option1_target_id: 4157
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20038:
  _id_: 20038
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10290
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20039:
  _id_: 20039
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10250
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20040:
  _id_: 20040
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4008
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20041:
  _id_: 20041
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10290
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20042:
  _id_: 20042
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10351
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20043:
  _id_: 20043
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10319
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20044:
  _id_: 20044
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4012
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20045:
  _id_: 20045
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10348
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20046:
  _id_: 20046
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10348
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20047:
  _id_: 20047
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10348
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20048:
  _id_: 20048
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10366
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 4201
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20049:
  _id_: 20049
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4011
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20050:
  _id_: 20050
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10348
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20051:
  _id_: 20051
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10369
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20052:
  _id_: 20052
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10370
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20053:
  _id_: 20053
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4010
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20054:
  _id_: 20054
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10319
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20055:
  _id_: 20055
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10377
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20056:
  _id_: 20056
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10309
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20057:
  _id_: 20057
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10309
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20058:
  _id_: 20058
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10385
  skill_option1_target_id: 1001
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 4209
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20059:
  _id_: 20059
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4009
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20060:
  _id_: 20060
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4008
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20061:
  _id_: 20061
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10389
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20062:
  _id_: 20062
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10391
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20063:
  _id_: 20063
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10319
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 52
  skill_option2_target_id: 1001
  skill_option2_time: 6
  skill_option2_value: 50
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20064:
  _id_: 20064
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10395
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20065:
  _id_: 20065
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20066:
  _id_: 20066
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10397
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20067:
  _id_: 20067
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10403
  skill_option1_target_id: 2002
  skill_option1_time: 6
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20068:
  _id_: 20068
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10385
  skill_option1_target_id: 1001
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 4198
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20069:
  _id_: 20069
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4013
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20070:
  _id_: 20070
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10371
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20071:
  _id_: 20071
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 8
  skill_option1_target_id: 4156
  skill_option1_time: 4
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20072:
  _id_: 20072
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10364
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20073:
  _id_: 20073
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4011
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20074:
  _id_: 20074
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1001
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20075:
  _id_: 20075
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10385
  skill_option1_target_id: 1001
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10411
  skill_option2_target_id: 2002
  skill_option2_time: 6
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10415
  skill_option3_target_id: 2002
  skill_option3_time: 6
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20076:
  _id_: 20076
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20077:
  _id_: 20077
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 8
  skill_option1_target_id: 4157
  skill_option1_time: 4
  skill_option1_value: 20
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20078:
  _id_: 20078
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20079:
  _id_: 20079
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10418
  skill_option2_target_id: 2002
  skill_option2_time: 6
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10420
  skill_option3_target_id: 2002
  skill_option3_time: 6
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20080:
  _id_: 20080
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10385
  skill_option1_target_id: 1001
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10298
  skill_option2_target_id: 4217
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10419
  skill_option3_target_id: 2002
  skill_option3_time: 6
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10421
  skill_option4_target_id: 2002
  skill_option4_time: 6
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20081:
  _id_: 20081
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10303
  skill_option1_target_id: 4012
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20082:
  _id_: 20082
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 4009
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20083:
  _id_: 20083
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10411
  skill_option2_target_id: 2002
  skill_option2_time: 6
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10415
  skill_option3_target_id: 2002
  skill_option3_time: 6
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20084:
  _id_: 20084
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20085:
  _id_: 20085
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10412
  skill_option2_target_id: 4006
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20086:
  _id_: 20086
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20087:
  _id_: 20087
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10385
  skill_option2_target_id: 1001
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10299
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10316
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 100
20088:
  _id_: 20088
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20089:
  _id_: 20089
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1001
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20090:
  _id_: 20090
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 4156
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20091:
  _id_: 20091
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10412
  skill_option2_target_id: 4006
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20092:
  _id_: 20092
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20093:
  _id_: 20093
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10350
  skill_option1_target_id: 1001
  skill_option1_time: 99
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10385
  skill_option2_target_id: 1001
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10299
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10316
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 100
20094:
  _id_: 20094
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10357
  skill_option1_target_id: 4090
  skill_option1_time: 1
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10422
  skill_option2_target_id: 4090
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10303
  skill_option3_target_id: 4090
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10319
  skill_option4_target_id: 4090
  skill_option4_time: 1
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20095:
  _id_: 20095
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10443
  skill_option1_target_id: 2002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10385
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10299
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10316
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 100
20096:
  _id_: 20096
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 4093
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 0
  skill_option2_target_id: 0
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20097:
  _id_: 20097
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10376
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 10412
  skill_option2_target_id: 4006
  skill_option2_time: 3
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20098:
  _id_: 20098
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10347
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 20026
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20099:
  _id_: 20099
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 20026
  skill_option1_target_id: 2002
  skill_option1_time: 0
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10452
  skill_option2_target_id: 2002
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10444
  skill_option3_target_id: 1001
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10449
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10316
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 100
20100:
  _id_: 20100
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10303
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10409
  skill_option3_target_id: 1001
  skill_option3_time: 1
  skill_option3_value: 100
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20101:
  _id_: 20101
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10446
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10422
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10406
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 100
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20102:
  _id_: 20102
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10409
  skill_option2_target_id: 1001
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20103:
  _id_: 20103
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4007
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 20026
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10456
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20104:
  _id_: 20104
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10460
  skill_option1_target_id: 1001
  skill_option1_time: 99
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10444
  skill_option2_target_id: 1001
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10449
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10343
  skill_option5_target_id: 1002
  skill_option5_time: 3
  skill_option5_value: 1
20105:
  _id_: 20105
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 20026
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 0
  skill_option3_target_id: 0
  skill_option3_time: 0
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20106:
  _id_: 20106
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10449
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 10
  skill_option2_hit_rate: 100
  skill_option2_id: 10446
  skill_option2_target_id: 1002
  skill_option2_time: 1
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10319
  skill_option4_target_id: 1002
  skill_option4_time: 1
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10303
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 0
20107:
  _id_: 20107
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4006
  skill_option1_time: 4
  skill_option1_value: 50
  skill_option2_hit_rate: 100
  skill_option2_id: 20028
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10456
  skill_option3_target_id: 2002
  skill_option3_time: 2
  skill_option3_value: 50
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20108:
  _id_: 20108
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10384
  skill_option1_target_id: 4090
  skill_option1_time: 3
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10458
  skill_option2_target_id: 4090
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 4090
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10444
  skill_option4_target_id: 1001
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10343
  skill_option5_target_id: 1002
  skill_option5_time: 3
  skill_option5_value: 1
20109:
  _id_: 20109
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10454
  skill_option1_target_id: 1002
  skill_option1_time: 1
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10446
  skill_option2_target_id: 1002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10303
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10409
  skill_option5_target_id: 1001
  skill_option5_time: 1
  skill_option5_value: 100
20110:
  _id_: 20110
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 20026
  skill_option1_target_id: 2002
  skill_option1_time: 0
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10452
  skill_option2_target_id: 2002
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10444
  skill_option3_target_id: 1001
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10449
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 10
  skill_option5_hit_rate: 100
  skill_option5_id: 10316
  skill_option5_target_id: 1002
  skill_option5_time: 1
  skill_option5_value: 100
20111:
  _id_: 20111
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10422
  skill_option1_target_id: 1002
  skill_option1_time: 2
  skill_option1_value: 0
  skill_option2_hit_rate: 100
  skill_option2_id: 10458
  skill_option2_target_id: 1001
  skill_option2_time: 2
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10399
  skill_option3_target_id: 1002
  skill_option3_time: 1
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 20026
  skill_option4_target_id: 2002
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20112:
  _id_: 20112
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10457
  skill_option1_target_id: 2002
  skill_option1_time: 0
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10470
  skill_option2_target_id: 2002
  skill_option2_time: 2
  skill_option2_value: 0
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 10
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20113:
  _id_: 20113
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10434
  skill_option1_target_id: 4156
  skill_option1_time: 3
  skill_option1_value: 100
  skill_option2_hit_rate: 100
  skill_option2_id: 10458
  skill_option2_target_id: 4156
  skill_option2_time: 1
  skill_option2_value: 100
  skill_option3_hit_rate: 100
  skill_option3_id: 10422
  skill_option3_target_id: 4156
  skill_option3_time: 2
  skill_option3_value: 0
  skill_option4_hit_rate: 100
  skill_option4_id: 10444
  skill_option4_target_id: 1001
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10343
  skill_option5_target_id: 1002
  skill_option5_time: 3
  skill_option5_value: 1
20114:
  _id_: 20114
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10464
  skill_option1_target_id: 1002
  skill_option1_time: 0
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10457
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 2
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 10
  skill_option4_hit_rate: 100
  skill_option4_id: 0
  skill_option4_target_id: 0
  skill_option4_time: 0
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 0
  skill_option5_target_id: 0
  skill_option5_time: 0
  skill_option5_value: 0
20115:
  _id_: 20115
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10464
  skill_option1_target_id: 1002
  skill_option1_time: 0
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10457
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 2
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 10446
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10444
  skill_option5_target_id: 1001
  skill_option5_time: 2
  skill_option5_value: 0
20116:
  _id_: 20116
  icon_id: 0
  rate: 100
  skill_option1_hit_rate: 100
  skill_option1_id: 10464
  skill_option1_target_id: 1002
  skill_option1_time: 0
  skill_option1_value: 2
  skill_option2_hit_rate: 100
  skill_option2_id: 10457
  skill_option2_target_id: 2002
  skill_option2_time: 0
  skill_option2_value: 2
  skill_option3_hit_rate: 100
  skill_option3_id: 10449
  skill_option3_target_id: 1002
  skill_option3_time: 2
  skill_option3_value: 15
  skill_option4_hit_rate: 100
  skill_option4_id: 10422
  skill_option4_target_id: 1002
  skill_option4_time: 2
  skill_option4_value: 0
  skill_option5_hit_rate: 100
  skill_option5_id: 10444
  skill_option5_target_id: 1001
  skill_option5_time: 2
  skill_option5_value: 0

*/

inline val dataGenTacticsSkill get() = """{"10001":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10292,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10001},"10002":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":89,"skill_option1_target_id":1143,"skill_option1_time":0,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10002},"10003":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":28,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":30000,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10003},"10004":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10250,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10004},"10005":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4011,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10005},"10006":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10298,"skill_option1_target_id":2002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10006},"10007":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10295,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10007},"10008":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10240,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10008},"10009":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10302,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10009},"10010":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10283,"skill_option1_target_id":4156,"skill_option1_time":6,"skill_option1_value":15,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10010},"10011":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10299,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":10294,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10011},"10012":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4009,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10012},"10013":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10283,"skill_option1_target_id":4157,"skill_option1_time":6,"skill_option1_value":15,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10013},"10014":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10311,"skill_option1_target_id":1002,"skill_option1_time":5,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10014},"10015":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4011,"skill_option1_time":6,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10015},"10016":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10310,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":99999,"skill_option2_hit_rate":100,"skill_option2_id":10309,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10016},"10017":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10110,"skill_option1_target_id":1002,"skill_option1_time":7,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10017},"10018":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10300,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10314,"skill_option2_target_id":2002,"skill_option2_time":1,"skill_option2_value":5,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10018},"10019":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10316,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10303,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10019},"10020":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10318,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10020},"10021":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4008,"skill_option1_time":6,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10021},"10022":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10314,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":5,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4013,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10022},"10023":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10292,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10322,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10023},"10024":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10328,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10298,"skill_option3_target_id":4197,"skill_option3_time":3,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10024},"10025":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10280,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10294,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10025},"10026":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4013,"skill_option1_time":6,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10026},"10027":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4010,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10027},"10028":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10299,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":10286,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10028},"10029":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4013,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10029},"10030":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10339,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10340,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10030},"10031":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4156,"skill_option1_time":6,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10031},"10032":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10343,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":1,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10032},"10033":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10345,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10033},"10034":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10302,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10316,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10034},"10035":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10110,"skill_option1_target_id":1002,"skill_option1_time":5,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10280,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10035},"10036":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4011,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10036},"10037":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4157,"skill_option1_time":6,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10037},"10038":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10349,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10348,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10038},"10039":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10050,"skill_option1_target_id":2002,"skill_option1_time":4,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10294,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10039},"10040":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4008,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10040},"10041":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10301,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10041},"10042":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10354,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":10355,"skill_option2_target_id":2002,"skill_option2_time":1,"skill_option2_value":2,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10042},"10043":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4009,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10043},"10044":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4012,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10044},"10045":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10347,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10362,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10045},"10046":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10050,"skill_option1_target_id":2002,"skill_option1_time":4,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10294,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10046},"10047":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10363,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10047},"10048":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10365,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10367,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10300,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10048},"10049":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4011,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10049},"10050":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10364,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10050},"10051":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10368,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10051},"10052":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10310,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":99999,"skill_option2_hit_rate":100,"skill_option2_id":10371,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10052},"10053":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4010,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10053},"10054":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4013,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10054},"10055":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10302,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10380,"skill_option2_target_id":2002,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10055},"10056":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10343,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":1,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10056},"10057":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10381,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10057},"10058":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10387,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10058},"10059":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4009,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10382,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10059},"10060":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4008,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10060},"10061":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10381,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10389,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10311,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10061},"10062":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10302,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10390,"skill_option2_target_id":2002,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10062},"10063":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10110,"skill_option1_target_id":1002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":4228,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10063},"10064":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10394,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10064},"10065":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4012,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10065},"10066":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10399,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10347,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10066},"10067":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10402,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10347,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10067},"10068":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10404,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10068},"10069":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4013,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10069},"10070":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10405,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10070},"10071":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10283,"skill_option1_target_id":4156,"skill_option1_time":6,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10071},"10072":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10404,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10072},"10073":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4011,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10073},"10074":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4010,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10402,"skill_option3_target_id":2002,"skill_option3_time":1,"skill_option3_value":2,"skill_option4_hit_rate":100,"skill_option4_id":10390,"skill_option4_target_id":2002,"skill_option4_time":4,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10074},"10075":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10402,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10300,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10075},"10076":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10050,"skill_option1_target_id":2002,"skill_option1_time":4,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10294,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10076},"10077":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10283,"skill_option1_target_id":4157,"skill_option1_time":6,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10077},"10078":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10350,"skill_option1_target_id":1141,"skill_option1_time":99,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10345,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10396,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":10300,"skill_option4_target_id":2002,"skill_option4_time":2,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":10356,"skill_option5_target_id":2002,"skill_option5_time":2,"skill_option5_value":0,"_id_":10078},"10079":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10347,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10352,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10301,"skill_option4_target_id":2002,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10079},"10080":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10399,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10416,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":2,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10080},"10081":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4012,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10100,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":20,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":4012,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10081},"10082":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4009,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10082},"10083":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10407,"skill_option1_target_id":2002,"skill_option1_time":3,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10423,"skill_option2_target_id":2002,"skill_option2_time":6,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10424,"skill_option3_target_id":2002,"skill_option3_time":6,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10083},"10084":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":1002,"skill_option1_time":5,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10376,"skill_option2_target_id":1002,"skill_option2_time":5,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10300,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10084},"10085":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10407,"skill_option1_target_id":2002,"skill_option1_time":3,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10311,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10399,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10085},"10086":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10412,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10404,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10300,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10086},"10087":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10343,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":1,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10299,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10087},"10088":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10405,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10088},"10089":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4008,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10423,"skill_option3_target_id":2002,"skill_option3_time":4,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10424,"skill_option4_target_id":2002,"skill_option4_time":4,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10089},"10090":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4156,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10090},"10091":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10407,"skill_option1_target_id":2002,"skill_option1_time":3,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10311,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10404,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10091},"10092":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10385,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10345,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":100,"skill_option4_hit_rate":100,"skill_option4_id":10316,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":100,"skill_option5_hit_rate":100,"skill_option5_id":10300,"skill_option5_target_id":2002,"skill_option5_time":2,"skill_option5_value":50,"_id_":10092},"10093":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10343,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":1,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10299,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10093},"10094":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4090,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10357,"skill_option2_target_id":4090,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":4090,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10303,"skill_option4_target_id":4090,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10319,"skill_option5_target_id":4090,"skill_option5_time":2,"skill_option5_value":0,"_id_":10094},"10095":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10445,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10300,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":10396,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":10299,"skill_option5_target_id":1002,"skill_option5_time":2,"skill_option5_value":15,"_id_":10095},"10096":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4093,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10406,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10096},"10097":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10300,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10400,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":2,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10097},"10098":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10450,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":10448,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":20,"skill_option3_hit_rate":100,"skill_option3_id":10447,"skill_option3_target_id":1002,"skill_option3_time":4,"skill_option3_value":10,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10098},"10099":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10451,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":10422,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10099},"10100":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4011,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10392,"skill_option3_target_id":2002,"skill_option3_time":4,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10100},"10101":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4157,"skill_option1_time":6,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10101},"10102":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10454,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10404,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10300,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":10396,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10102},"10103":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10444,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10345,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":100,"skill_option4_hit_rate":100,"skill_option4_id":10416,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":2,"skill_option5_hit_rate":100,"skill_option5_id":10300,"skill_option5_target_id":2002,"skill_option5_time":2,"skill_option5_value":50,"_id_":10103},"10104":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":1002,"skill_option1_time":3,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":10459,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":100,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10104},"10105":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10451,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10434,"skill_option2_target_id":1141,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":10422,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10105},"10106":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10282,"skill_option1_target_id":4008,"skill_option1_time":6,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10447,"skill_option2_target_id":1002,"skill_option2_time":3,"skill_option2_value":30,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":4008,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":10106},"10107":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10444,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10345,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":100,"skill_option4_hit_rate":100,"skill_option4_id":10416,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":2,"skill_option5_hit_rate":100,"skill_option5_id":10300,"skill_option5_target_id":2002,"skill_option5_time":2,"skill_option5_value":50,"_id_":10107},"10108":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10298,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":4090,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10282,"skill_option3_target_id":4090,"skill_option3_time":6,"skill_option3_value":30,"skill_option4_hit_rate":100,"skill_option4_id":10461,"skill_option4_target_id":2404,"skill_option4_time":3,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10456,"skill_option5_target_id":2404,"skill_option5_time":3,"skill_option5_value":50,"_id_":10108},"10109":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10338,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":30,"skill_option2_hit_rate":100,"skill_option2_id":10319,"skill_option2_target_id":4009,"skill_option2_time":4,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10461,"skill_option3_target_id":2002,"skill_option3_time":4,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10343,"skill_option4_target_id":1002,"skill_option4_time":3,"skill_option4_value":1,"skill_option5_hit_rate":100,"skill_option5_id":10456,"skill_option5_target_id":4230,"skill_option5_time":3,"skill_option5_value":50,"_id_":10109},"10110":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10458,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10449,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":15,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10396,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":10404,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":0,"_id_":10110},"10111":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10434,"skill_option1_target_id":4007,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10454,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10467,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10300,"skill_option4_target_id":2002,"skill_option4_time":2,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":10396,"skill_option5_target_id":1002,"skill_option5_time":2,"skill_option5_value":50,"_id_":10111},"10112":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10434,"skill_option1_target_id":4006,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10454,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10447,"skill_option3_target_id":1001,"skill_option3_time":1,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":10445,"skill_option4_target_id":2123,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10396,"skill_option5_target_id":1002,"skill_option5_time":2,"skill_option5_value":50,"_id_":10112},"10113":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10298,"skill_option1_target_id":2002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10396,"skill_option2_target_id":4156,"skill_option2_time":2,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":10282,"skill_option3_target_id":4156,"skill_option3_time":6,"skill_option3_value":30,"skill_option4_hit_rate":100,"skill_option4_id":10461,"skill_option4_target_id":4230,"skill_option4_time":3,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10471,"skill_option5_target_id":1002,"skill_option5_time":3,"skill_option5_value":100,"_id_":10113},"10114":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10434,"skill_option1_target_id":1143,"skill_option1_time":2,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10469,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10467,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10451,"skill_option4_target_id":2002,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10449,"skill_option5_target_id":1002,"skill_option5_time":2,"skill_option5_value":15,"_id_":10114},"10115":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10434,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10451,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":3,"skill_option3_value":25,"skill_option4_hit_rate":100,"skill_option4_id":10396,"skill_option4_target_id":1002,"skill_option4_time":3,"skill_option4_value":50,"skill_option5_hit_rate":100,"skill_option5_id":10422,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":0,"_id_":10115},"10116":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10450,"skill_option1_target_id":1002,"skill_option1_time":4,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":10448,"skill_option2_target_id":1002,"skill_option2_time":4,"skill_option2_value":30,"skill_option3_hit_rate":100,"skill_option3_id":10447,"skill_option3_target_id":1002,"skill_option3_time":4,"skill_option3_value":30,"skill_option4_hit_rate":100,"skill_option4_id":10443,"skill_option4_target_id":2002,"skill_option4_time":3,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10449,"skill_option5_target_id":1002,"skill_option5_time":4,"skill_option5_value":25,"_id_":10116},"20001":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10285,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20001},"20002":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10285,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20002},"20003":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10080,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20003},"20004":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10293,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20004},"20005":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4011,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20005},"20006":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10150,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20006},"20007":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10150,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20007},"20008":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10150,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20008},"20009":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10285,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20009},"20010":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":8,"skill_option1_target_id":4156,"skill_option1_time":4,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20010},"20011":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10293,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20011},"20012":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4009,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20012},"20013":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":8,"skill_option1_target_id":4157,"skill_option1_time":4,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20013},"20014":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20014},"20015":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4011,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20015},"20016":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20016},"20017":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10080,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20017},"20018":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20018},"20019":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10250,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20019},"20020":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10250,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20020},"20021":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4008,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20021},"20022":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10319,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20022},"20023":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20023},"20024":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10322,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20024},"20025":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10250,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20025},"20026":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4013,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20026},"20027":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4010,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20027},"20028":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20028},"20029":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4013,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20029},"20030":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10297,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20030},"20031":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4156,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20031},"20032":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10322,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20032},"20033":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10309,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20033},"20034":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10309,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20034},"20035":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4012,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20035},"20036":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10319,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20036},"20037":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":392,"skill_option1_target_id":4157,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20037},"20038":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10290,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20038},"20039":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10250,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20039},"20040":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4008,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20040},"20041":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10290,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20041},"20042":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10351,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20042},"20043":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10319,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20043},"20044":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4012,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20044},"20045":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10348,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20045},"20046":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10348,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20046},"20047":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10348,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20047},"20048":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10366,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":4201,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20048},"20049":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4011,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20049},"20050":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10348,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20050},"20051":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10369,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20051},"20052":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10370,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20052},"20053":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4010,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20053},"20054":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10319,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20054},"20055":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10377,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20055},"20056":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10309,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20056},"20057":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10309,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20057},"20058":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10385,"skill_option1_target_id":1001,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":4209,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20058},"20059":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4009,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20059},"20060":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4008,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20060},"20061":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10389,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20061},"20062":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10391,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20062},"20063":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10319,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":52,"skill_option2_target_id":1001,"skill_option2_time":6,"skill_option2_value":50,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20063},"20064":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10395,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20064},"20065":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20065},"20066":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10397,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20066},"20067":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10403,"skill_option1_target_id":2002,"skill_option1_time":6,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20067},"20068":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10385,"skill_option1_target_id":1001,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":4198,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20068},"20069":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4013,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20069},"20070":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10371,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20070},"20071":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":8,"skill_option1_target_id":4156,"skill_option1_time":4,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20071},"20072":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10364,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20072},"20073":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4011,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20073},"20074":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1001,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20074},"20075":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10385,"skill_option1_target_id":1001,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10411,"skill_option2_target_id":2002,"skill_option2_time":6,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10415,"skill_option3_target_id":2002,"skill_option3_time":6,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20075},"20076":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20076},"20077":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":8,"skill_option1_target_id":4157,"skill_option1_time":4,"skill_option1_value":20,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20077},"20078":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20078},"20079":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10418,"skill_option2_target_id":2002,"skill_option2_time":6,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10420,"skill_option3_target_id":2002,"skill_option3_time":6,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20079},"20080":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10385,"skill_option1_target_id":1001,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10298,"skill_option2_target_id":4217,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10419,"skill_option3_target_id":2002,"skill_option3_time":6,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10421,"skill_option4_target_id":2002,"skill_option4_time":6,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20080},"20081":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10303,"skill_option1_target_id":4012,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20081},"20082":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":4009,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20082},"20083":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10411,"skill_option2_target_id":2002,"skill_option2_time":6,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10415,"skill_option3_target_id":2002,"skill_option3_time":6,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20083},"20084":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20084},"20085":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10412,"skill_option2_target_id":4006,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20085},"20086":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20086},"20087":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10385,"skill_option2_target_id":1001,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10299,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10316,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":100,"_id_":20087},"20088":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20088},"20089":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1001,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20089},"20090":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":4156,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20090},"20091":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10412,"skill_option2_target_id":4006,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20091},"20092":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20092},"20093":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10350,"skill_option1_target_id":1001,"skill_option1_time":99,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10385,"skill_option2_target_id":1001,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10299,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10316,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":100,"_id_":20093},"20094":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10357,"skill_option1_target_id":4090,"skill_option1_time":1,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10422,"skill_option2_target_id":4090,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10303,"skill_option3_target_id":4090,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10319,"skill_option4_target_id":4090,"skill_option4_time":1,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20094},"20095":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10443,"skill_option1_target_id":2002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10385,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10299,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10316,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":100,"_id_":20095},"20096":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":4093,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":0,"skill_option2_target_id":0,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20096},"20097":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10376,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":10412,"skill_option2_target_id":4006,"skill_option2_time":3,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20097},"20098":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10347,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":20026,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20098},"20099":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":20026,"skill_option1_target_id":2002,"skill_option1_time":0,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10452,"skill_option2_target_id":2002,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10444,"skill_option3_target_id":1001,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10449,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10316,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":100,"_id_":20099},"20100":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10303,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10409,"skill_option3_target_id":1001,"skill_option3_time":1,"skill_option3_value":100,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20100},"20101":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10446,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10422,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10406,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":100,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20101},"20102":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10409,"skill_option2_target_id":1001,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20102},"20103":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4007,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":20026,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10456,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20103},"20104":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10460,"skill_option1_target_id":1001,"skill_option1_time":99,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10444,"skill_option2_target_id":1001,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10449,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10343,"skill_option5_target_id":1002,"skill_option5_time":3,"skill_option5_value":1,"_id_":20104},"20105":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":20026,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":0,"skill_option3_target_id":0,"skill_option3_time":0,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20105},"20106":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10449,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":10,"skill_option2_hit_rate":100,"skill_option2_id":10446,"skill_option2_target_id":1002,"skill_option2_time":1,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10319,"skill_option4_target_id":1002,"skill_option4_time":1,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10303,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":0,"_id_":20106},"20107":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4006,"skill_option1_time":4,"skill_option1_value":50,"skill_option2_hit_rate":100,"skill_option2_id":20028,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10456,"skill_option3_target_id":2002,"skill_option3_time":2,"skill_option3_value":50,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20107},"20108":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10384,"skill_option1_target_id":4090,"skill_option1_time":3,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10458,"skill_option2_target_id":4090,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":4090,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10444,"skill_option4_target_id":1001,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10343,"skill_option5_target_id":1002,"skill_option5_time":3,"skill_option5_value":1,"_id_":20108},"20109":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10454,"skill_option1_target_id":1002,"skill_option1_time":1,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10446,"skill_option2_target_id":1002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10303,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10409,"skill_option5_target_id":1001,"skill_option5_time":1,"skill_option5_value":100,"_id_":20109},"20110":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":20026,"skill_option1_target_id":2002,"skill_option1_time":0,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10452,"skill_option2_target_id":2002,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10444,"skill_option3_target_id":1001,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10449,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":10,"skill_option5_hit_rate":100,"skill_option5_id":10316,"skill_option5_target_id":1002,"skill_option5_time":1,"skill_option5_value":100,"_id_":20110},"20111":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10422,"skill_option1_target_id":1002,"skill_option1_time":2,"skill_option1_value":0,"skill_option2_hit_rate":100,"skill_option2_id":10458,"skill_option2_target_id":1001,"skill_option2_time":2,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10399,"skill_option3_target_id":1002,"skill_option3_time":1,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":20026,"skill_option4_target_id":2002,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20111},"20112":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10457,"skill_option1_target_id":2002,"skill_option1_time":0,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10470,"skill_option2_target_id":2002,"skill_option2_time":2,"skill_option2_value":0,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":10,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20112},"20113":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10434,"skill_option1_target_id":4156,"skill_option1_time":3,"skill_option1_value":100,"skill_option2_hit_rate":100,"skill_option2_id":10458,"skill_option2_target_id":4156,"skill_option2_time":1,"skill_option2_value":100,"skill_option3_hit_rate":100,"skill_option3_id":10422,"skill_option3_target_id":4156,"skill_option3_time":2,"skill_option3_value":0,"skill_option4_hit_rate":100,"skill_option4_id":10444,"skill_option4_target_id":1001,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10343,"skill_option5_target_id":1002,"skill_option5_time":3,"skill_option5_value":1,"_id_":20113},"20114":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10464,"skill_option1_target_id":1002,"skill_option1_time":0,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10457,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":2,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":10,"skill_option4_hit_rate":100,"skill_option4_id":0,"skill_option4_target_id":0,"skill_option4_time":0,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":0,"skill_option5_target_id":0,"skill_option5_time":0,"skill_option5_value":0,"_id_":20114},"20115":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10464,"skill_option1_target_id":1002,"skill_option1_time":0,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10457,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":2,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":10446,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10444,"skill_option5_target_id":1001,"skill_option5_time":2,"skill_option5_value":0,"_id_":20115},"20116":{"icon_id":0,"rate":100,"skill_option1_hit_rate":100,"skill_option1_id":10464,"skill_option1_target_id":1002,"skill_option1_time":0,"skill_option1_value":2,"skill_option2_hit_rate":100,"skill_option2_id":10457,"skill_option2_target_id":2002,"skill_option2_time":0,"skill_option2_value":2,"skill_option3_hit_rate":100,"skill_option3_id":10449,"skill_option3_target_id":1002,"skill_option3_time":2,"skill_option3_value":15,"skill_option4_hit_rate":100,"skill_option4_id":10422,"skill_option4_target_id":1002,"skill_option4_time":2,"skill_option4_value":0,"skill_option5_hit_rate":100,"skill_option5_id":10444,"skill_option5_target_id":1001,"skill_option5_time":2,"skill_option5_value":0,"_id_":20116}}"""
